"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Camera_exports = {};
__export(Camera_exports, {
  default: () => Camera_default
});
module.exports = __toCommonJS(Camera_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12.4922 4.41016C12.6484 4.41016 12.7917 4.45573 12.9219 4.54688C13.0521 4.625 13.1562 4.73568 13.2344 4.87891L13.7227 5.85547C13.7487 5.92057 13.7943 5.97917 13.8594 6.03125C13.9375 6.07031 14.0156 6.08984 14.0938 6.08984H17.1602C17.3945 6.08984 17.5898 6.17448 17.7461 6.34375C17.9154 6.5 18 6.6888 18 6.91016V15.25C18 15.4844 17.9154 15.6862 17.7461 15.8555C17.5898 16.0117 17.3945 16.0898 17.1602 16.0898H3.83984C3.60547 16.0898 3.40365 16.0117 3.23438 15.8555C3.07812 15.6862 3 15.4844 3 15.25V6.91016C3 6.6888 3.07812 6.5 3.23438 6.34375C3.40365 6.17448 3.60547 6.08984 3.83984 6.08984H6.90625C6.98438 6.08984 7.05599 6.07031 7.12109 6.03125C7.19922 5.97917 7.2513 5.92057 7.27734 5.85547L7.76562 4.87891C7.84375 4.73568 7.94792 4.625 8.07812 4.54688C8.20833 4.45573 8.35156 4.41016 8.50781 4.41016H12.4922ZM12.4922 5.25H8.50781L8.01953 6.22656C7.92839 6.42188 7.79167 6.58464 7.60938 6.71484C7.4401 6.83203 7.24479 6.89714 7.02344 6.91016H6.90625H3.83984V15.25H17.1602V6.91016H14.0938C13.8724 6.91016 13.6641 6.85807 13.4688 6.75391C13.2865 6.64974 13.1367 6.50651 13.0195 6.32422L12.9609 6.22656L12.4922 5.25ZM10.5 7.75C11.4245 7.75 12.2122 8.07552 12.8633 8.72656C13.5143 9.3776 13.8398 10.1654 13.8398 11.0898C13.8398 12.0013 13.5143 12.7826 12.8633 13.4336C12.2122 14.0846 11.4245 14.4102 10.5 14.4102C9.57552 14.4102 8.78776 14.0846 8.13672 13.4336C7.48568 12.7826 7.16016 12.0013 7.16016 11.0898C7.16016 10.1654 7.48568 9.3776 8.13672 8.72656C8.78776 8.07552 9.57552 7.75 10.5 7.75ZM10.5 8.58984C9.8099 8.58984 9.21745 8.83724 8.72266 9.33203C8.24089 9.8138 8 10.3997 8 11.0898C8 11.7799 8.24089 12.3724 8.72266 12.8672C9.21745 13.349 9.8099 13.5898 10.5 13.5898C11.1901 13.5898 11.776 13.349 12.2578 12.8672C12.7526 12.3724 13 11.7799 13 11.0898C13 10.3997 12.7526 9.8138 12.2578 9.33203C11.776 8.83724 11.1901 8.58984 10.5 8.58984ZM15.9102 7.75C16.0273 7.75 16.125 7.78906 16.2031 7.86719C16.2943 7.94531 16.3398 8.04297 16.3398 8.16016C16.3398 8.27734 16.2943 8.38151 16.2031 8.47266C16.125 8.55078 16.0273 8.58984 15.9102 8.58984H15.0898C14.9727 8.58984 14.8685 8.55078 14.7773 8.47266C14.6992 8.38151 14.6602 8.27734 14.6602 8.16016C14.6602 8.04297 14.6992 7.94531 14.7773 7.86719C14.8685 7.78906 14.9727 7.75 15.0898 7.75H15.9102Z",
      fill: "currentColor"
    }
  )
);
const SvgCamera = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Camera_default = SvgCamera;
